import ItemTable from "./itemTable.container";

export default ItemTable;
